import { initializeApp } from "firebase/app";
import {
  getAuth,
  FacebookAuthProvider,
  GithubAuthProvider,
  GoogleAuthProvider,
  PhoneAuthProvider,
  browserSessionPersistence,
  setPersistence,
} from "firebase/auth";
import { FIREBASE_CONFIG } from "./config";

const app = initializeApp(FIREBASE_CONFIG);

const auth = getAuth(app);

// Use the standard Firebase Auth initialization that registers popup/redirect
// dependencies. Session persistence keeps browser-close behavior unchanged.
setPersistence(auth, browserSessionPersistence).catch(() => {
  // Fall back to Firebase's default persistence if storage is unavailable.
});

const FBProvider = new FacebookAuthProvider();
const GHProvider = new GithubAuthProvider();
const GoogleProvider = new GoogleAuthProvider();
const PhoneProvider = new PhoneAuthProvider(auth);
FBProvider.addScope("email");
FBProvider.setCustomParameters({ display: 'popup' });
GoogleProvider.addScope("email");
GoogleProvider.setCustomParameters({ prompt: 'select_account' });

export { app, auth, FBProvider, GHProvider, GoogleProvider, PhoneProvider };
